// @ts-expect-error untyped
import tinymce from 'tinymce';
import { getPluginSetting } from '../utils';
import { __HS_COPILOT_COLLABORATION } from '../constants/plugins';
import { addControls } from './controls';
import { initHighlightCommandsPlugin } from './highlight';
import { initAutocompletePluginWithSlashCommands } from './slash';
import { initFocusOrSelectionHandlers } from './initFocusOrSelectionHandlers';
import { CONTENT_ASSISTANT_SETTINGS, SUPER_ADMIN_SCOPE, hsContentAssistantConfig } from '../constants/hscontentgeneration';
import { getHighlightCommandsWithHandler, getSlashCommandsWithHandler } from './handlerUtils';
import { hasScope } from '../utils/settings';
export function hsCopilotCollaborationPlugin(editor) {
  const caSettings = getPluginSetting(editor, CONTENT_ASSISTANT_SETTINGS);
  const {
    // @ts-expect-error incorrect setting type (context in https://git.hubteam.com/HubSpot/hubspot-tinymce/pull/3958#discussion_r3344862)
    [hsContentAssistantConfig.IS_DISABLED]: isDisabled,
    // @ts-expect-error incorrect setting type
    [hsContentAssistantConfig.SELECTION_COMMANDS]: selectionCommands = [],
    // @ts-expect-error incorrect setting type
    [hsContentAssistantConfig.SLASH_COMMANDS]: slashCommands = [],
    // [hsContentAssistantConfig.BRAND_VOICE_OPTIONS]: brandVoiceOptions = {},

    // Used to pass function references from elsewhere in the app's React tree to the plugin
    // @ts-expect-error incorrect setting type
    [hsContentAssistantConfig.COPILOT_COLLAB_CONTEXT_VALUE]: copilotCollabContextValue,
    // @ts-expect-error incorrect setting type
    [hsContentAssistantConfig.BRAND_VOICE_OPTIONS]: brandVoiceOptions = {}
  } = caSettings;
  const {
    scopes
  } = editor.settings;
  const isSuperAdmin = hasScope(SUPER_ADMIN_SCOPE, scopes);
  if (isDisabled) {
    addControls(editor, isDisabled, [], [], brandVoiceOptions, isSuperAdmin);
  } else {
    if (!copilotCollabContextValue) {
      throw new Error('No copilotCollabContextValue passed to hsCopilotCollaborationPlugin');
    }
    const {
      commandHandler,
      focusHandler,
      sessionId
    } = copilotCollabContextValue;
    if (!commandHandler) {
      throw new Error('No commandHandler passed to copilotCollabContextValue');
    } else if (!focusHandler) {
      throw new Error('No focusHandler passed to copilotCollabContextValue');
    }
    const highlightCommandWithHandler = getHighlightCommandsWithHandler(selectionCommands, commandHandler, sessionId);
    const slashCommandsWithHandler = getSlashCommandsWithHandler(slashCommands, commandHandler, sessionId);
    addControls(editor, isDisabled, highlightCommandWithHandler, slashCommandsWithHandler, brandVoiceOptions, isSuperAdmin);
    initHighlightCommandsPlugin(editor, highlightCommandWithHandler, brandVoiceOptions);
    initAutocompletePluginWithSlashCommands(editor, slashCommandsWithHandler);
    initFocusOrSelectionHandlers(editor, focusHandler,
    // @ts-expect-error untyped
    editor.settings.focusEvents,
    // @ts-expect-error untyped
    editor.settings.blurEvents);
  }
}
export const HS_COPILOT_COLLABORATION = __HS_COPILOT_COLLABORATION;
tinymce.PluginManager.add(HS_COPILOT_COLLABORATION, hsCopilotCollaborationPlugin);